import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function PublicRoute({ children }: { children: React.ReactNode }) {
  const { isAuth, isAuthLoading } = useAuth();

  if (isAuthLoading) {
    return null;
  }

  if (isAuth) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}